import { apiBaseUrl } from './config';
import { sendPostRequest } from './utils';

const baseUrl = `${apiBaseUrl}/contact`;

async function sendHomeContactForm(payload) {
  return sendPostRequest(`${baseUrl}/`, payload);
}

export {
  sendHomeContactForm
};
